/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import { emailReg } from 'constants/index';
import { useCallbackWithLoader } from 'hooks/useCallbackWithLoader';
import useOnClickOutside from 'hooks/useOnClickOutside';
import { useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useSendTestEmailMutation } from 'store/api/version-api.slice';

import { styles } from './styles';

const ModalTestEmail = ({ handleClose, data, wrapperClassname = {} }) => {
	const [value, setChangeValue] = useState();
	const [sendTestEmail] = useSendTestEmailMutation();

	const { callback: sendEmail, loading } = useCallbackWithLoader(sendTestEmail);

	const handleChangeValue = e => {
		setChangeValue(e.target.value);
	};

	const ref = useRef();
	useOnClickOutside(ref, handleClose);

	const isSendButtonDisabled = useMemo(() => {
		return loading || !value || !emailReg.test(value) || !data.email_subject || !data.email_body;
	}, [loading, value, data.email_body, data.email_subject]);

	const handleSubmit = async () => {
		const response = await sendEmail({ subject: data.email_subject, body: data.email_body, to_email: value });

		if (response.error) {
			toast(response.error.data, { type: 'error' });
		} else {
			toast('Sent successfully. Please check you mailbox.', { type: 'info' });
			handleClose();
		}
	};

	return (
		<Box sx={{ ...styles.modalBackdrop, ...wrapperClassname }}>
			<Box sx={styles.modalWrapper} ref={ref}>
				<Box sx={styles.contentWrapper}>
					<p>Send Test Email to:</p>
					<Input type="email" value={value} onChange={handleChangeValue} />
				</Box>
				<Button
					disabled={isSendButtonDisabled}
					sx={styles.btnSend}
					variant="contained"
					color={'secondary'}
					onClick={handleSubmit}
				>
					Send Test
				</Button>
			</Box>
		</Box>
	);
};

export default ModalTestEmail;
